
export class Drawable {

	/**
	 * @param {CanvasRenderingContext2D} ctx
	 */
	draw(ctx) {
	}
}